import script from "./BaseFormItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFormItem.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFormItem.vue?vue&type=style&index=0&id=242669a1&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242669a1"]])

export default __exports__